import { render, staticRenderFns } from "./CardChallengesPicture.vue?vue&type=template&id=4392e2db&"
import script from "./CardChallengesPicture.vue?vue&type=script&lang=js&"
export * from "./CardChallengesPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports